var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageSolid = function SvgImageSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.144.625c-5.118 0-5.519.4-5.519 5.519v7.712c0 5.118.401 5.519 5.519 5.519h7.712c5.118 0 5.519-.4 5.519-5.519V6.144c0-5.118-.4-5.519-5.519-5.519zM4.922 2.5h10.156c2.246 0 2.422.176 2.422 2.422v8.234l-2.963-2.663a1.88 1.88 0 0 0-2.512.004L8.77 13.441l-1.296-1.11a1.875 1.875 0 0 0-2.442.005L2.5 14.516V4.922c0-2.246.176-2.422 2.422-2.422M6.72 5.313a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75"
  })));
};
export default SvgImageSolid;